export class Currency {
  static USD_CODE = 'usd';
  static EUR_CODE = 'eur';
  static RUB_CODE = 'rub';
  static IDR_CODE = 'idr';
  static VND_CODE = 'vnd';
  static KZT_CODE = 'kzt';
  static INR_CODE = 'inr';

  static USD_ID = 1;
  static EUR_ID = 2;
  static RUB_ID = 3;
  static IDR_ID = 4;
  static VND_ID = 5;
  static KZT_ID = 6;
  static INR_ID = 7;

  static ALLOWED = [
    Currency.RUB_CODE,
    Currency.EUR_CODE,
    Currency.USD_CODE,
    Currency.IDR_CODE,
    Currency.VND_CODE,
    Currency.KZT_CODE,
    Currency.INR_CODE
  ];

  static ObjectList = [
    {
      id: Currency.USD_ID,
      title: Currency.USD_CODE
    },
    {
      id: Currency.EUR_ID,
      title: Currency.EUR_CODE
    },
    {
      id: Currency.RUB_ID,
      title: Currency.RUB_CODE
    },
    {
      id: Currency.IDR_ID,
      title: Currency.IDR_CODE
    },
    {
      id: Currency.VND_ID,
      title: Currency.VND_CODE
    },
    {
      id: Currency.KZT_ID,
      title: Currency.KZT_CODE
    },
    {
      id: Currency.INR_ID,
      title: Currency.INR_CODE
    }
  ];

  static getDefault() {
    return Currency.EUR;
  }

  static isAllowed(val) {
    return Currency.ALLOWED.includes(`${val}`.toLowerCase());
  }
}
